if (!customElements.get('klove-product-gallery')) {
  customElements.define('klove-product-gallery', class extends HTMLElement {
    get activeImage() { return this.slides?.[this.index || 0]?.querySelector('img') || null; }
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
      if (!this.track || !this.slides.length) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const previous = this.querySelector('[data-gallery-previous]');
      const next = this.querySelector('[data-gallery-next]');
      const count = this.querySelector('[data-gallery-count]');
      const controls = this.querySelector('[data-gallery-controls]');
      const update = () => {
        if (previous) previous.disabled = this.index === 0;
        if (next) next.disabled = this.index === this.slides.length - 1;
        if (count) count.textContent = this.dataset.countLabel.replace('[current]', String(this.index + 1));
      };
      this.index = 0;
      this.show = (index, instant = false) => {
        this.index = Math.max(0, Math.min(this.slides.length - 1, index));
        this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: instant || reduced.matches ? 'instant' : 'smooth' });
        update();
      };
      const onScroll = () => {
        const index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / (this.track.clientWidth || 1))));
        if (index !== this.index) { this.index = index; update(); }
      };
      this.track.addEventListener('scroll', onScroll, { passive: true, signal });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.show(event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, { signal });
      previous?.addEventListener('click', () => this.show(this.index - 1), { signal });
      next?.addEventListener('click', () => this.show(this.index + 1), { signal });
      // Return to the packshot when the selected configuration changes.
      this.closest('bed-configurator')?.addEventListener('change', () => this.show(0, true), { signal });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => { if (!signal.aborted) this.show(this.index, true); });
        this.resizeObserver.observe(this.track);
      } else window.addEventListener('resize', () => this.show(this.index, true), { signal });
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(this)) this.disconnectedCallback();
      }, { signal });
      if (controls) controls.hidden = this.slides.length < 2;
      update();
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      this.controller?.abort();
      this.controller = null;
    }
  });
}
